import React from 'react';
import {json} from "helpers/data";
import { useTranslation } from 'react-i18next';

interface Props {
    tags: any[],
    labelField?: string
}

function TagsList({tags, labelField = 'name'}: Props) {
    const {t} = useTranslation()
    if (tags.length <= 0 ) return  null
    return (
        <div className='related-tags'>
            <h1 className='title'>{t('details:addonDetails.relatedTags')}</h1>
            <div className='all-tags'>
                {tags.map(tag => tag ? <div className='tags' key={tag.id}>{json(tag[labelField])}</div> : null)}
            </div>
        </div>
    );
}

export default TagsList;